"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBannerLazy = exports.BannerComponentLoader = void 0;
const PaymentMethodsBanner_1 = require("@wix/cashier-core/dist/src/services/PaymentMethodsBanner");
const react_1 = __importStar(require("react"));
const ModuleRegistry_1 = require("@wix/cashier-common/dist/src/rmc-fork/ModuleRegistry");
const ReactLazyComponent_1 = require("@wix/cashier-common/dist/src/rmc-fork/ReactLazyComponent");
const PaymentMethod_1 = require("@wix/cashier-core/dist/src/services/PaymentMethod");
const yieldToMain_1 = require("@wix/cashier-common/dist/src/utils/yieldToMain");
const mbMinified_1 = require("@wix/cashier-common/dist/src/rmc-fork/mbMinified");
const fedopsLogger_1 = require("../utils/fedopsLogger");
const lazy_1 = require("../utils/biLogger/lazy");
const InteractionName_1 = require("../utils/fedopsLogger/InteractionName");
const utils_1 = require("../utils/serverAPI/utils");
const panoramaClient_1 = require("../utils/panoramaClient");
const config_1 = require("./config");
const applyVersionOverride_1 = require("./applyVersionOverride");
class BannerComponentLoader extends ReactLazyComponent_1.ReactLazyComponent {
    static buildFiles(props) {
        // the reason for this as that hadron returns different staticsUrl in wix-bootstrap-ng and serverless
        const bannerStaticsBaseUrl = props.bannerSettings.bannerStaticsBaseUrl.replace(/\/$/, '');
        return [
            `${bannerStaticsBaseUrl}/${config_1.BANNER_BUNDLE_FILE_NAME}${(0, mbMinified_1.mbMinified)(props.debug)}.css`,
            `${bannerStaticsBaseUrl}/${config_1.BANNER_BUNDLE_FILE_NAME}.bundle${(0, mbMinified_1.mbMinified)(props.debug)}.js`,
        ];
    }
    constructor(props) {
        super(props, {
            component: config_1.BANNER_COMPONENT_ID,
            files: BannerComponentLoader.buildFiles(props),
            crossorigin: true,
        });
    }
}
exports.BannerComponentLoader = BannerComponentLoader;
class PaymentMethodsBannerLazy extends react_1.Component {
    async fetchBannerSettings() {
        var _a, _b;
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.FetchBannerSettings);
        (_a = this.panoramaClient) === null || _a === void 0 ? void 0 : _a.transaction(InteractionName_1.InteractionName.FetchBannerSettings).start();
        const service = new PaymentMethodsBanner_1.PaymentMethodsBannerService({
            baseURL: '/',
            appInstance: this.props.meta.appInstance,
            revalidateAppInstance: this.props.revalidateAppInstance,
        });
        let settings = await service.fetchBannerSettings();
        fedopsLogger_1.fedopsLogger.interactionEnded(InteractionName_1.InteractionName.FetchBannerSettings);
        (_b = this.panoramaClient) === null || _b === void 0 ? void 0 : _b.transaction(InteractionName_1.InteractionName.FetchBannerSettings).finish();
        settings = (0, applyVersionOverride_1.applyVersionOverride)(settings);
        return settings;
    }
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.state = {
            settings: undefined,
            isLazyLoadFailed: false,
        };
        this.fetchBuyNowPayLaterMethods = async () => {
            const { appDefId, appInstanceId } = this.props.meta;
            const { amount, locale: language, currency } = this.props;
            const service = new PaymentMethod_1.PaymentMethodService({
                baseURL: '/',
                appInstance: this.props.meta.appInstance,
                revalidateAppInstance: this.props.revalidateAppInstance,
                enableRetry: false,
            });
            const { paymentMethods } = await service.fetchBuyNowPayLaterMethods((0, utils_1.buildAccountId)({ appDefId, appInstanceId }), {
                amount,
                language,
                currency,
                supportDelayedCapture: this.props.delayedCapture,
            });
            return paymentMethods;
        };
        this.biLoggerFactory = (0, lazy_1.createBiLoggerFactory)(Object.assign(Object.assign({}, props.meta), { delayedCapture: this.props.delayedCapture }));
        this.panoramaClient = (0, panoramaClient_1.initPanoramaClient)({
            fullArtifactId: config_1.FULL_ARTIFACT_ID,
            componentId: config_1.ARTIFACT_NAME,
        });
        const errorHandler = (error) => {
            var _a;
            if ((error === null || error === void 0 ? void 0 : error.name) === 'LazyComponentLoadingError' && ((_a = error.message) === null || _a === void 0 ? void 0 : _a.endsWith(config_1.BANNER_COMPONENT_ID))) {
                console.error(`Payment methods banner: Failed to load main bundle`, error);
                if (this._isMounted) {
                    this.setState({ isLazyLoadFailed: true });
                }
            }
        };
        this.removeLoadFailureListener = (0, ModuleRegistry_1.getModuleRegistry)().addListener('reactModuleContainer.error', errorHandler).remove;
    }
    async componentDidMount() {
        var _a;
        await (0, yieldToMain_1.yieldToMain)();
        fedopsLogger_1.fedopsLogger.appLoadStarted();
        (_a = this.panoramaClient) === null || _a === void 0 ? void 0 : _a.reportLoadFinish();
        (0, lazy_1.reportBannerLoadStartBiEvent)(Object.assign(Object.assign({}, this.props.meta), { delayedCapture: this.props.delayedCapture }));
        try {
            const settings = await this.fetchBannerSettings();
            this.setState({ settings });
        }
        catch (e) {
            this.setState({ isLazyLoadFailed: true });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
        if (typeof this.removeLoadFailureListener === 'function') {
            this.removeLoadFailureListener();
        }
    }
    render() {
        const { isLazyLoadFailed, settings } = this.state;
        if (isLazyLoadFailed || !settings) {
            return null;
        }
        return (react_1.default.createElement(BannerComponentLoader, Object.assign({}, this.props, { panoramaClient: this.panoramaClient, bannerSettings: settings, biLoggerFactory: this.biLoggerFactory, fedopsLogger: fedopsLogger_1.fedopsLogger, fetchBuyNowPayLaterMethods: this.fetchBuyNowPayLaterMethods })));
    }
}
exports.PaymentMethodsBannerLazy = PaymentMethodsBannerLazy;
//# sourceMappingURL=PaymentMethodsBannerLazy.js.map